/**
 * Web Style Import
 *
 */

import './style/dnb-slider.scss'
